(ns frontend.components.tab-strip
  (:require [reagent.core :as r]
            [frontend.utils :as fu]))

(defn component [{:keys [on-change! tabs default-tab-key tab-strip-id]}]
  (let [state (r/atom {})]
    (r/create-class
     {:component-did-mount (fn [_]
                             (when-not (:selected-tab @state)
                               (swap! state assoc :selected-tab default-tab-key)
                               (on-change! default-tab-key)))
      :reagent-render      (fn [{:keys [on-change! tabs default-tab-key tab-strip-id]}]
                             (let [selected-tab (:selected-tab @state)]
                               [:ul.zap-tab-strip
                                (->> tabs
                                     (map (fn [{:keys [tab-key tab-label] :as tab}]
                                            [:li
                                             {:key        (str "zap-tab-" tab-strip-id "-" tab-key)
                                              :class-name (fu/cs :zap-tab-option
                                                                 (when (= selected-tab tab-key)
                                                                   "selected-tab selected-tab--servicehub"
                                                                   ))
                                              :on-click   (fn [_]
                                                            (swap! state assoc :selected-tab tab-key)
                                                            (on-change! tab-key))}
                                             tab-label]))
                                     (doall))]))})))
